import { render, staticRenderFns } from "./KaoguanjianduGrade.vue?vue&type=template&id=20a20a7e&"
import script from "./KaoguanjianduGrade.vue?vue&type=script&lang=js&"
export * from "./KaoguanjianduGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports